<template>
  <div class="cardCustom">
    <div class="card cardCustom__side">
      <div class="cardCustom__header">
        <div class="cardCustom__header-text">
          <span class="uppercase">
            {{ title }}
          </span>
        </div>
        <div class="chart-dropdown">
          <slot name="dropdown"></slot>
        </div>
        <div class="cardCustom__header-info__item">
          <button
            v-if="infoText"
            v-tooltip="{
              content: infoText,
              placement: 'bottom-center',
              classes: ['info'],
            }"
          >
            <i class="fas fa-info-circle" />
          </button>
        </div>
      </div>
      <div class="content pt-3 pb-3 small">
        <div v-if="loading" :class="{ bgBlur: true }" :style="blurStyles"></div>
        <bar-chart :chartData="chartData" :options="options" :styles="myStyles"></bar-chart>
        <div v-if="loading" class="loadingSection lds-dual-ring"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from './Card.vue';
import CardWithSides from '@/components/Cards/CardWithSides';
import BarChart from '../../controllers/Charts/BarChart';

export default {
  name: 'BarChartCard',
  components: {
    CardWithSides,
    Card,
    BarChart,
  },
  props: {
    infoText: String,
    title: String,
    subTitle: String,
    loading: Boolean,
    chartData: {
      type: Object,
      default: null,
    },
    chartHeight: {
      type: Number,
      default: 190,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  computed: {
    myStyles() {
      return {
        height: `${this.chartHeight}px`,
        position: 'relative',
      };
    },
    blurStyles() {
      return {
        height: `${this.chartHeight}px`,
      };
    },
  },
};
</script>
<style>
.small {
  margin-top: 3rem;
}
</style>
